/**
 * app-constants 用 i18n定数
 */

// ========================================
// スタッフ職種
// ========================================
export const STAFF_JOB_TITLES_I18N = {
  MD: $localize`:@@constants.staffJobTitles.MD:医師`,
  DDS: $localize`:@@constants.staffJobTitles.DDS:歯科医師`,
  DH: $localize`:@@constants.staffJobTitles.DH:歯科衛生士`,
  NS: $localize`:@@constants.staffJobTitles.NS:訪問看護師`,
  PT: $localize`:@@constants.staffJobTitles.PT:理学療法士`,
  OT: $localize`:@@constants.staffJobTitles.OT:作業療法士`,
  ST: $localize`:@@constants.staffJobTitles.ST:言語聴覚士`,
  RD: $localize`:@@constants.staffJobTitles.RD:栄養士`,
  CW: $localize`:@@constants.staffJobTitles.CW:介護職`,
  OTHER: $localize`:@@constants.staffJobTitles.OTHER:その他`,
} as const;

// ========================================
// スタッフ権限
// ========================================
export const STAFF_ROLES_I18N = {
  PRIMARY: $localize`:@@constants.staffRoles.PRIMARY:セクションの管理者の代表。セクションに最低ひとり必要`,
  ACCOUNT_MANAGEMENT: $localize`:@@constants.staffRoles.ACCOUNT_MANAGEMENT:スタッフの管理を行う`,
  USER_MANAGEMENT: $localize`:@@constants.staffRoles.USER_MANAGEMENT:一般ユーザの管理を行う`,
  MEASUREMENT: $localize`:@@constants.staffRoles.MEASUREMENT:計測を行う`,
  REFER: $localize`:@@constants.staffRoles.REFER:計測結果を見る`,
} as const;

// ========================================
// クォータモデル
// ========================================
export const QUOTA_MODELS_I18N = {
  SHARED: $localize`:@@constants.quotaModels.SHARED:グループで共有`,
  DEDICATED: $localize`:@@constants.quotaModels.DEDICATED:セクションだけで独自のデータ量を設定`,
} as const;

// ========================================
// セクショングループ管理者権限
// ========================================
export const SECTION_GROUP_ADMIN_ROLES_I18N = {
  SECTION_MANAGEMENT: $localize`:@@constants.sectionGroupAdminRoles.SECTION_MANAGEMENT:このセクショングループ内のセクションの作成・変更・停止`,
  SECTION_GROUP_ADMIN_MANAGEMENT: $localize`:@@constants.sectionGroupAdminRoles.SECTION_GROUP_ADMIN_MANAGEMENT:このセクショングループの管理者の追加・変更・停止`,
  SECTION_GROUP_UPDATE: $localize`:@@constants.sectionGroupAdminRoles.SECTION_GROUP_UPDATE:このセクショングループの変更`,
  SECTION_GROUP_BILLING_INFO_MANAGEMENT: $localize`:@@constants.sectionGroupAdminRoles.SECTION_GROUP_BILLING_INFO_MANAGEMENT:このセクショングループの請求情報の変更`,
} as const;

// ========================================
// システム管理者権限
// ========================================
export const SYSTEM_ADMIN_ROLES_I18N = {
  ALL_SECTION_GROUP_MANAGEMENT: $localize`:@@constants.systemAdminRoles.ALL_SECTION_GROUP_MANAGEMENT:すべてのセクショングループの作成・変更・停止`,
  SECTION_GROUP_CREATE: $localize`:@@constants.systemAdminRoles.SECTION_GROUP_CREATE:セクショングループの作成`,
  PARAMETER_MANAGEMENT: $localize`:@@constants.systemAdminRoles.PARAMETER_MANAGEMENT:システムパラメータの変更`,
  SYSTEM_ADMIN_MANAGEMENT: $localize`:@@constants.systemAdminRoles.SYSTEM_ADMIN_MANAGEMENT:システム全体の管理者の追加・変更・停止`,
  DISTRIBUTOR_MANAGEMENT: $localize`:@@constants.systemAdminRoles.DISTRIBUTOR_MANAGEMENT:代理店の追加・変更・停止`,
  ALL_DISTRIBUTOR_AGENT_MANAGEMENT: $localize`:@@constants.systemAdminRoles.ALL_DISTRIBUTOR_AGENT_MANAGEMENT:代理店のエージェントの追加・変更・停止`,
  QUOTA_MANAGEMENT: $localize`:@@constants.systemAdminRoles.QUOTA_MANAGEMENT:セクション 及び セクショングループ のデータ使用量上限の変更`,
} as const;

// ========================================
// セクショングループ機能
// ========================================
export const SECTION_GROUP_FUNCTIONS_I18N = {
  UserData: $localize`:@@constants.sectionGroupFunctions.UserData:ユーザの詳細データを記録する`,
  Video: $localize`:@@constants.sectionGroupFunctions.Video:メディアをアップロードする`,
  Dialog: $localize`:@@constants.sectionGroupFunctions.Dialog:連絡帳機能を使用する`,
  RecordList: $localize`:@@constants.sectionGroupFunctions.RecordList:各種計測データを一覧する`,
  STETHOSCOPE: $localize`:@@constants.sectionGroupFunctions.STETHOSCOPE:聴診器モードを利用する`,
  GOST: $localize`:@@constants.sectionGroupFunctions.GOST:GOSTを計測する`,
  SST: $localize`:@@constants.sectionGroupFunctions.SST:SSTを計測する`,
  MONITORING: $localize`:@@constants.sectionGroupFunctions.MONITORING:モニタリングを行う`,
  VS: $localize`:@@constants.sectionGroupFunctions.VS:VSを計測する`,
  RSST: $localize`:@@constants.sectionGroupFunctions.RSST:RSSTを計測する`,
  MWST: $localize`:@@constants.sectionGroupFunctions.MWST:MWSTを計測する`,
  FOOD: $localize`:@@constants.sectionGroupFunctions.FOOD:FOOD TESTを行う`,
  TOMASS: $localize`:@@constants.sectionGroupFunctions.TOMASS:TOMASSを計測する`,
  PCT: $localize`:@@constants.sectionGroupFunctions.PCT:PCTを計測する`,
  GUIDE_POSTURE: $localize`:@@constants.sectionGroupFunctions.GUIDE_POSTURE:Postureを計測する`,
  TOMASS_SUM: $localize`:@@constants.sectionGroupFunctions.TOMASS_SUM:TOMASSのサマリーを表示する`,
  SSTPLUS: $localize`:@@constants.sectionGroupFunctions.SSTPLUS:SSTPLUSを計測する`,
  NB4CONFIG: $localize`:@@constants.sectionGroupFunctions.NB4CONFIG:ネックバンドの設定を行う`,
} as const;

// ========================================
// ユーザー職種
// ========================================
export const USER_JOB_TITLES_I18N = {
  NU: $localize`:@@constants.userJobTitles.NU:一般ユーザー`,
} as const;

// ========================================
// ステータス
// ========================================
export const STATUS_I18N = {
  open: $localize`:@@constants.status.open:有効`,
  close: $localize`:@@constants.status.close:無効`,
} as const;

export const PRICING_MODEL_I18N = {
  fixed: $localize`:@@constants.pricingModel.fixed:固定`,
  perUser: $localize`:@@constants.pricingModel.perUser:ユーザ数に応じて`,
  perSection: $localize`:@@constants.pricingModel.perSection:セクション数に応じて`,
  perSectionGroup: $localize`:@@constants.pricingModel.perSectionGroup:セクショングループ数に応じて`,
  perDataGB: $localize`:@@constants.pricingModel.perDataGB:アップロードデータ量に応じて`,
} as const;

export const PAYMENT_METHOD_I18N = {
  Invoice: $localize`:@@constants.paymentMethod.invoice:請求書払い`,
  CreditCard: $localize`:@@constants.pricingModel.CreditCard:クレジットカード払い`,
  DirectDebit: $localize`:@@constants.pricingModel.DirectDebit:銀行引き落とし`,
} as const;



export const SECTION_GROUP_CONTRACT_CHANNEL_I18N = {
  direct: $localize`:@@constants.status.direct:直接契約`,
  distributor: $localize`:@@constants.status.distributor:代理店経由`,
} as const;

export const SECTION_BILL_TO_TYPE_I18N = {
  direct: $localize`:@@constants.status.direct:セクション単独で`,
  sectionGroup: $localize`:@@constants.status.sectionGroup:セクショングループでまとめて`,
  distributor: $localize`:@@constants.status.distributor:代理店経由`,
} as const;
